/* eslint react/no-danger: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import CopyrightWeatherby from '../../shared/copyright/CopyrightWeatherby';

const SireReference = ({ data: { data } }) => {
    if (!data) {
        return (
            <section
                className="hp-sireReference__container--text-center"
            >
                No sire reference information for this sire is available

                <CopyrightWeatherby />
            </section>
        );
    }

    const { sireReferenceHTMLflat } = data;

    return (
        <div>
            <section
                className="hp-weatherbys__sireReference hp-sireReference__container"
                dangerouslySetInnerHTML={{ __html: sireReferenceHTMLflat }}
            />

            <CopyrightWeatherby />
        </div>
    );
};

SireReference.propTypes = {
    data: PropTypes.shape({
        data: PropTypes.shape({
            sireReferenceHTMLflat: PropTypes.string,
        }),
    }),
};

export default SireReference;



// WEBPACK FOOTER //
// ./src/js/horse/sireReference/SireReference.jsx